import React from 'react';
import { SummaryList, Button } from 'govuk-react-jsx';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getPmcLandlordType,
  getPmcLinkedEnterprise,
  getPMCData,
} from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';

const CheckAnswers = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const landlordTypeRedux = useSelector(getPmcLandlordType);
  const linkedEnterpriseRedux = useSelector(getPmcLinkedEnterprise);
  const pmcDataRedux = useSelector(getPMCData);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.CheckAnswers.s10',
    'Check your answers - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const history = useHistory();

  const handleBtnClick = () => {
    history.push('/pmcClientReg/declaration');
  };

  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'pmcClientReg.CheckAnswers.s1',
          'Check your answers'
        )}
      </h1>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('pmcClientReg.CheckAnswers.s2', 'Client details')}
      </h2>
      <SummaryList
        className="govuk-summary-list govuk-!-margin-bottom-9"
        rows={[
          {
            key: {
              children: copyProvider.getCopy(
                'pmcClientReg.CheckAnswers.s3',
                'Type of landlord'
              ),
            },
            value: {
              children: <p className="govuk-body">{landlordTypeRedux}</p>,
            },
          },
          {
            key: {
              children: copyProvider.getCopy(
                'pmcClientReg.CheckAnswers.s4',
                'Linked enterprise'
              ),
            },
            value: {
              children: (
                <p className="govuk-body ">{linkedEnterpriseRedux || 'No'}</p>
              ),
            },
          },
          pmcDataRedux.companyRegNumber && {
            key: {
              children: copyProvider.getCopy(
                'pmcClientReg.CheckAnswers.s5',
                'Companies House number'
              ),
            },
            value: {
              children: (
                <p className="govuk-body ">{pmcDataRedux.companyRegNumber}</p>
              ),
            },
          },
          pmcDataRedux.vatRegNumber && {
            key: {
              children: copyProvider.getCopy(
                'pmcClientReg.CheckAnswers.s6',
                'UK VAT registration number'
              ),
            },
            value: {
              children: (
                <p className="govuk-body ">{pmcDataRedux.vatRegNumber}</p>
              ),
            },
          },
          {
            key: {
              children: copyProvider.getCopy(
                'pmcClientReg.CheckAnswers.s7',
                'Company name'
              ),
            },
            value: {
              children: (
                <p className="govuk-body">{pmcDataRedux.businessName}</p>
              ),
            },
          },
          {
            key: {
              children: copyProvider.getCopy(
                'pmcClientReg.CheckAnswers.s8',
                'Business address'
              ),
            },
            value: {
              children: (
                <div key="0" className="govuk-body">
                  <p className="govuk-body">
                    <section>
                      {pmcDataRedux.businessAddressLine1 &&
                        `${pmcDataRedux.businessAddressLine1},`}
                    </section>
                    <section>
                      {pmcDataRedux.businessAddressLine2 &&
                        `${pmcDataRedux.businessAddressLine2},`}
                    </section>
                    <section>
                      {pmcDataRedux.businessAddressCity &&
                        `${pmcDataRedux.businessAddressCity},`}
                    </section>
                    <section>
                      {pmcDataRedux.businessAddressCounty &&
                        `${pmcDataRedux.businessAddressCounty},`}
                    </section>
                    <section>
                      {pmcDataRedux.businessAddressPostcode &&
                        pmcDataRedux.businessAddressPostcode}
                      {pmcDataRedux.businessAddressCountry && ','}
                    </section>
                    <section>
                      {pmcDataRedux.businessAddressCountry &&
                        pmcDataRedux.businessAddressCountry}
                    </section>
                  </p>
                </div>
              ),
            },
          },
        ]}
      />

      <Button
        className="govuk-button govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'pmcClientReg.CheckAnswers.s9',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default CheckAnswers;
